import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { SuiviFacture } from '@/models/SuiviFacture';
import { AxiosResponse } from 'axios';
import { PageResponse } from '@/common/utils/PageResponse';
import RechercheFactureDTO from '@/models/RechercheFactureDTO';

export interface FacturesParams {
    page?: number;
    sort?: string;
    joursAvantEcheance?: number;
    nbDerniersMois?: number;
    societe?: string;
    etablissement?: string;
    site?: string;
    fournisseur?: string;
    numeroFacture?: string;
    dateFrom?: string;
    dateTo?: string;
    comparison?: string;
    montant?: number;
    chantierIds?: number[];
}

export interface SuiviFinancierParams {
    page?: number;
    sort?: string;
    chantierIds: number[];
    dateDebutPeriodeRechercheParDate: string;
    dateFinPeriodeRechercheParDate: string;
    id: number;
    typeInterventionExtranetIds: number[];
}

export interface RechercheSuiviFinancier {
    chantierIds: number[];
    dateDebut: string;
    dateFin: string;
}

class SuiviFacturesService {
    public async getSuiviFacturesEnRetard(params: FacturesParams): Promise<AxiosResponse<PageResponse<SuiviFacture>>> {
        try {
            const rechercheFactures: RechercheFactureDTO = new RechercheFactureDTO(params);
            return await http.get(Routes.BillingRoutes.GetFacturesEnRetard(), { params: rechercheFactures });
        } catch (error) {
            console.error('Erreur lors de la r�cup�ration des factures en retard', error);
            throw error;
        }
    }

    public async getSuiviFacturesAvantEcheance(params: FacturesParams): Promise<AxiosResponse<PageResponse<SuiviFacture>>> {
        try {
            const rechercheFactures: RechercheFactureDTO = new RechercheFactureDTO(params);
            return await http.get(Routes.BillingRoutes.GetFacturesAvantEcheance(), { params: rechercheFactures });
        } catch (error) {
            console.error('Erreur lors de la r�cup�ration des factures avant �ch�ance', error);
            throw error;
        }
    }

    public async getFacturePdf(numeroFacture: string, societeId: number): Promise<any> {
        return http.get(Routes.BillingRoutes.GetFacturePdf(numeroFacture, societeId), { responseType: 'arraybuffer' });
    }
    public async getTypesIntervention(): Promise<any[]> {
        return http.get(Routes.TypesInterventionRoutes.GetTypesInterventions());
    }
    public async getSuiviFactures(params: SuiviFinancierParams): Promise<any> {
        return http.get(Routes.BillingRoutes.GetFactures(), { params });
    }
    public async getSuiviFacturesXls(): Promise<any> {
        return http.get(Routes.BillingRoutes.GetFacturesXls(), {responseType: 'arraybuffer'});
    }
    public async getFacturePdfByInterventionId(interventionId: number, chantierId: number): Promise<any> {
        return http.get(Routes.BillingRoutes.GetFacturePdfByInterventionId(interventionId, chantierId), { responseType: 'arraybuffer' });
    }
    public async getSuiviFacturesPayees(params: FacturesParams): Promise<AxiosResponse<PageResponse<SuiviFacture>>> {
        try {
            const rechercheFactures: RechercheFactureDTO = new RechercheFactureDTO(params);
            return await http.get(Routes.BillingRoutes.GetFacturesPayees(), { params: rechercheFactures });
        } catch (error) {
            console.error('Erreur lors de la r�cup�ration des factures pay�es', error);
            throw error;
        }
    }

}

export default new SuiviFacturesService();
